import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoftware = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3232_8117",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 1,
		y: 0,
		width: 15,
		height: 15,
		children: /* @__PURE__ */ _jsx("rect", {
			x: 1,
			width: 15,
			height: 15,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_3232_8117)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.875 8.03125L7.3125 8.57812C7.19792 8.69271 7.05469 8.75 6.88281 8.75C6.71094 8.75 6.5625 8.6875 6.4375 8.5625C6.32292 8.44792 6.26562 8.30208 6.26562 8.125C6.26562 7.94792 6.32292 7.80208 6.4375 7.6875L8.0625 6.0625C8.1875 5.9375 8.33333 5.875 8.5 5.875C8.66667 5.875 8.8125 5.9375 8.9375 6.0625L10.5625 7.6875C10.6771 7.80208 10.737 7.94531 10.7422 8.11719C10.7474 8.28906 10.6875 8.4375 10.5625 8.5625C10.4479 8.67708 10.3047 8.73698 10.1328 8.74219C9.96094 8.7474 9.8125 8.69271 9.6875 8.57812L9.125 8.03125V11.25H12.5625C13 11.25 13.3698 11.099 13.6719 10.7969C13.974 10.4948 14.125 10.125 14.125 9.6875C14.125 9.25 13.974 8.88021 13.6719 8.57812C13.3698 8.27604 13 8.125 12.5625 8.125H11.625V6.875C11.625 6.01042 11.3203 5.27344 10.7109 4.66406C10.1016 4.05469 9.36458 3.75 8.5 3.75C7.63542 3.75 6.89844 4.05469 6.28906 4.66406C5.67969 5.27344 5.375 6.01042 5.375 6.875H5.0625C4.45833 6.875 3.94271 7.08854 3.51562 7.51563C3.08854 7.94271 2.875 8.45833 2.875 9.0625C2.875 9.66667 3.08854 10.1823 3.51562 10.6094C3.94271 11.0365 4.45833 11.25 5.0625 11.25H6C6.17708 11.25 6.32552 11.3099 6.44531 11.4297C6.5651 11.5495 6.625 11.6979 6.625 11.875C6.625 12.0521 6.5651 12.2005 6.44531 12.3203C6.32552 12.4401 6.17708 12.5 6 12.5H5.0625C4.11458 12.5 3.30469 12.1719 2.63281 11.5156C1.96094 10.8594 1.625 10.0573 1.625 9.10938C1.625 8.29688 1.86979 7.57292 2.35938 6.9375C2.84896 6.30208 3.48958 5.89583 4.28125 5.71875C4.54167 4.76042 5.0625 3.98438 5.84375 3.39063C6.625 2.79688 7.51042 2.5 8.5 2.5C9.71875 2.5 10.7526 2.92448 11.6016 3.77344C12.4505 4.6224 12.875 5.65625 12.875 6.875C13.5938 6.95833 14.1901 7.26823 14.6641 7.80469C15.138 8.34115 15.375 8.96875 15.375 9.6875C15.375 10.4688 15.1016 11.1328 14.5547 11.6797C14.0078 12.2266 13.3438 12.5 12.5625 12.5H9.125C8.78125 12.5 8.48698 12.3776 8.24219 12.1328C7.9974 11.888 7.875 11.5938 7.875 11.25V8.03125Z",
			fill: "#2C3F81"
		})
	})]
});
export default SvgSoftware;
